import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { JsonReturn } from '../shared/interface/generic-interface';

@Injectable()
export class TruckInfoService 
{
  pesoBruto: number = 0;
  cubagem: number = 0;
  veiculoCargaPeso: number = 0;
  veiculoCubagem: number = 0;
  vlKilometro: number = 0;
  
  public selectedTruck: any;
  public tiposVeiculo: any;

  categoriaPedagiosVeiculos = [
    { codCategoriaPedagio: null, descricao: 'Sem Categ. ', qtdeEixo: 0, imagemPath:'assets/img/auto2eixos.svg' },
    { codCategoriaPedagio: 1, descricao: 'Moto' , qtdeEixo: 0, imagemPath:'assets/img/Moto_2_icon.svg' },
    { codCategoriaPedagio: 2 , descricao: 'Auto', qtdeEixo: 2, imagemPath:'assets/img/auto2eixos.svg' },
    { codCategoriaPedagio: 3, descricao: 'Auto' , qtdeEixo: 3, imagemPath:'assets/img/auto3eixos.svg' },
    { codCategoriaPedagio: 4, descricao: 'Auto' , qtdeEixo: 4, imagemPath:'assets/img/auto4eixos.svg' },
    { codCategoriaPedagio: 5, descricao: 'Caminhão', qtdeEixo: 2, imagemPath:'assets/img/caminhao2eixos.svg' },
    { codCategoriaPedagio: 6, descricao: 'Caminhão', qtdeEixo: 3, imagemPath:'assets/img/caminhao3eixos.svg' },
    { codCategoriaPedagio: 7, descricao: 'Caminhão', qtdeEixo: 4, imagemPath:'assets/img/caminhao4eixos.svg' },
    { codCategoriaPedagio: 8, descricao: 'Caminhão', qtdeEixo: 5, imagemPath:'assets/img/caminhao5eixos.svg' },
    { codCategoriaPedagio: 9, descricao: 'Caminhão', qtdeEixo: 6, imagemPath:'assets/img/caminhao6eixos.svg' },
    { codCategoriaPedagio: 10, descricao: 'Caminhão', qtdeEixo: 7, imagemPath:'assets/img/caminhao6eixos.svg' },
    { codCategoriaPedagio: 11, descricao: 'Caminhão', qtdeEixo: 8, imagemPath:'assets/img/caminhao6eixos.svg' },
    { codCategoriaPedagio: 12, descricao: 'Caminhão', qtdeEixo: 9, imagemPath:'assets/img/caminhao6eixos.svg' },
    { codCategoriaPedagio: 13, descricao: 'Caminhão' , qtdeEixo: 10, imagemPath:'assets/img/caminhao6eixos.svg' },
    { codCategoriaPedagio: 14, descricao: 'Ônibus', qtdeEixo: 2, imagemPath:'assets/img/caminhao2eixos.svg' },
    { codCategoriaPedagio: 15, descricao: 'Ônibus', qtdeEixo: 3, imagemPath:'assets/img/caminhao2eixos.svg' },
    { codCategoriaPedagio: 16, descricao: 'Ônibus', qtdeEixo: 4, imagemPath:'assets/img/caminhao2eixos.svg' },
    { codCategoriaPedagio: 17, descricao: 'Ônibus', qtdeEixo: 4, imagemPath:'assets/img/caminhao2eixos.svg' },
  ]

  constructor 
  (
    private conService: ApiConService
  ) 
  { }

  async getTrucks() 
  {
    try 
    {
      const response: JsonReturn = await this.conService.patch('tipoVeiculo');
      this.tiposVeiculo = response.response;

      return response[0];
    }
    catch (Error) {
      console.log("CATCH________getTrucks");
      console.log(Error);
    }
  }
}